import { render, staticRenderFns } from "./supplier-commitments-viewer.vue?vue&type=template&id=8ad57c64&scoped=true"
import script from "./supplier-commitments-viewer.vue?vue&type=script&lang=js"
export * from "./supplier-commitments-viewer.vue?vue&type=script&lang=js"
import style0 from "./supplier-commitments-viewer.vue?vue&type=style&index=0&id=8ad57c64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad57c64",
  null
  
)

export default component.exports